export default __webpack_public_path__ + "static/media/DSC05598.5385ce58.jpg";